var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLouisiana(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170.62,
    height: 156.813,
    viewBox: "0 0 170.62 156.813",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#f0a022}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_louisiana",
    transform: "translate(-6.75 -962.612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3588",
    d: "M11.681 965.078a2.466 2.466 0 1 1-2.465-2.465 2.466 2.466 0 0 1 2.465 2.465z",
    className: "cls-1",
    "data-name": "Path 3588"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3589",
    d: "M11.681 968.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3589",
    transform: "translate(0 3.404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3590",
    d: "M11.681 972.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3590",
    transform: "translate(0 6.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3591",
    d: "M11.681 975.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3591",
    transform: "translate(0 10.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3592",
    d: "M11.681 979.077a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3592",
    transform: "translate(0 13.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3593",
    d: "M11.681 982.578a2.466 2.466 0 1 1-2.465-2.466 2.466 2.466 0 0 1 2.465 2.466z",
    className: "cls-1",
    "data-name": "Path 3593",
    transform: "translate(0 17.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3594",
    d: "M11.681 986.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3594",
    transform: "translate(0 20.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3595",
    d: "M11.681 989.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3595",
    transform: "translate(0 23.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3596",
    d: "M15.181 965.078a2.466 2.466 0 1 1-2.465-2.465 2.466 2.466 0 0 1 2.465 2.465z",
    className: "cls-1",
    "data-name": "Path 3596",
    transform: "translate(3.404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3597",
    d: "M15.181 968.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3597",
    transform: "translate(3.404 3.404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3598",
    d: "M15.181 972.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3598",
    transform: "translate(3.404 6.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3599",
    d: "M15.181 975.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3599",
    transform: "translate(3.404 10.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3600",
    d: "M15.181 979.077a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3600",
    transform: "translate(3.404 13.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3601",
    d: "M15.181 982.578a2.466 2.466 0 1 1-2.465-2.466 2.466 2.466 0 0 1 2.465 2.466z",
    className: "cls-1",
    "data-name": "Path 3601",
    transform: "translate(3.404 17.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3602",
    d: "M15.181 986.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3602",
    transform: "translate(3.404 20.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3603",
    d: "M15.181 989.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3603",
    transform: "translate(3.404 23.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3604",
    d: "M15.181 993.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3604",
    transform: "translate(3.404 27.23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3605",
    d: "M15.181 996.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3605",
    transform: "translate(3.404 30.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3606",
    d: "M15.181 1014.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3606",
    transform: "translate(3.404 47.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3607",
    d: "M15.181 1017.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3607",
    transform: "translate(3.404 51.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3608",
    d: "M15.181 1021.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3608",
    transform: "translate(3.404 54.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3609",
    d: "M15.181 1024.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3609",
    transform: "translate(3.404 57.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3610",
    d: "M15.181 1028.078a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3610",
    transform: "translate(3.404 61.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3611",
    d: "M15.181 1031.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3611",
    transform: "translate(3.404 64.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3612",
    d: "M18.681 965.078a2.466 2.466 0 1 1-2.465-2.465 2.466 2.466 0 0 1 2.465 2.465z",
    className: "cls-1",
    "data-name": "Path 3612",
    transform: "translate(6.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3613",
    d: "M18.681 968.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3613",
    transform: "translate(6.807 3.404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3614",
    d: "M18.681 972.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3614",
    transform: "translate(6.807 6.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3615",
    d: "M18.681 975.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3615",
    transform: "translate(6.807 10.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3616",
    d: "M18.681 979.077a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3616",
    transform: "translate(6.807 13.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3617",
    d: "M18.681 982.578a2.466 2.466 0 1 1-2.465-2.466 2.466 2.466 0 0 1 2.465 2.466z",
    className: "cls-1",
    "data-name": "Path 3617",
    transform: "translate(6.807 17.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3618",
    d: "M18.681 986.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3618",
    transform: "translate(6.807 20.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3619",
    d: "M18.681 989.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3619",
    transform: "translate(6.807 23.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3620",
    d: "M18.681 993.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3620",
    transform: "translate(6.807 27.23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3621",
    d: "M18.681 996.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3621",
    transform: "translate(6.807 30.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3622",
    d: "M18.681 1000.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3622",
    transform: "translate(6.807 34.037)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3623",
    d: "M18.681 1003.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3623",
    transform: "translate(6.807 37.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3624",
    d: "M18.681 1007.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3624",
    transform: "translate(6.807 40.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3625",
    d: "M18.681 1010.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3625",
    transform: "translate(6.807 44.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3626",
    d: "M18.681 1014.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3626",
    transform: "translate(6.807 47.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3627",
    d: "M18.681 1017.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3627",
    transform: "translate(6.807 51.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3628",
    d: "M18.681 1021.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3628",
    transform: "translate(6.807 54.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3629",
    d: "M18.681 1024.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3629",
    transform: "translate(6.807 57.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3630",
    d: "M18.681 1028.078a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3630",
    transform: "translate(6.807 61.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3631",
    d: "M22.181 965.078a2.466 2.466 0 1 1-2.465-2.465 2.466 2.466 0 0 1 2.465 2.465z",
    className: "cls-1",
    "data-name": "Path 3631",
    transform: "translate(10.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3632",
    d: "M22.181 968.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3632",
    transform: "translate(10.211 3.404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3633",
    d: "M22.181 972.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3633",
    transform: "translate(10.211 6.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3634",
    d: "M22.181 975.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3634",
    transform: "translate(10.211 10.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3635",
    d: "M22.181 979.077a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3635",
    transform: "translate(10.211 13.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3636",
    d: "M22.181 982.578a2.466 2.466 0 1 1-2.465-2.466 2.466 2.466 0 0 1 2.465 2.466z",
    className: "cls-1",
    "data-name": "Path 3636",
    transform: "translate(10.211 17.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3637",
    d: "M22.181 986.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3637",
    transform: "translate(10.211 20.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3638",
    d: "M22.181 989.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3638",
    transform: "translate(10.211 23.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3639",
    d: "M22.181 993.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3639",
    transform: "translate(10.211 27.23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3640",
    d: "M22.181 996.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3640",
    transform: "translate(10.211 30.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3641",
    d: "M22.181 1000.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3641",
    transform: "translate(10.211 34.037)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3642",
    d: "M22.181 1003.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3642",
    transform: "translate(10.211 37.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3643",
    d: "M22.181 1007.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3643",
    transform: "translate(10.211 40.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3644",
    d: "M22.181 1010.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3644",
    transform: "translate(10.211 44.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3645",
    d: "M22.181 1014.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3645",
    transform: "translate(10.211 47.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3646",
    d: "M22.181 1017.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3646",
    transform: "translate(10.211 51.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3647",
    d: "M22.181 1021.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3647",
    transform: "translate(10.211 54.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3648",
    d: "M22.181 1024.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3648",
    transform: "translate(10.211 57.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3649",
    d: "M22.181 1028.078a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3649",
    transform: "translate(10.211 61.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3650",
    d: "M25.681 965.078a2.466 2.466 0 1 1-2.465-2.465 2.466 2.466 0 0 1 2.465 2.465z",
    className: "cls-1",
    "data-name": "Path 3650",
    transform: "translate(13.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3651",
    d: "M25.681 968.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3651",
    transform: "translate(13.615 3.404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3652",
    d: "M25.681 972.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3652",
    transform: "translate(13.615 6.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3653",
    d: "M25.681 975.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3653",
    transform: "translate(13.615 10.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3654",
    d: "M25.681 979.077a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3654",
    transform: "translate(13.615 13.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3655",
    d: "M25.681 982.578a2.466 2.466 0 1 1-2.465-2.466 2.466 2.466 0 0 1 2.465 2.466z",
    className: "cls-1",
    "data-name": "Path 3655",
    transform: "translate(13.615 17.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3656",
    d: "M25.681 986.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3656",
    transform: "translate(13.615 20.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3657",
    d: "M25.681 989.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3657",
    transform: "translate(13.615 23.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3658",
    d: "M25.681 993.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3658",
    transform: "translate(13.615 27.23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3659",
    d: "M25.681 996.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3659",
    transform: "translate(13.615 30.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3660",
    d: "M25.681 1000.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3660",
    transform: "translate(13.615 34.037)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3661",
    d: "M25.681 1003.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3661",
    transform: "translate(13.615 37.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3662",
    d: "M25.681 1007.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3662",
    transform: "translate(13.615 40.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3663",
    d: "M25.681 1010.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3663",
    transform: "translate(13.615 44.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3664",
    d: "M25.681 1014.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3664",
    transform: "translate(13.615 47.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3665",
    d: "M25.681 1017.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3665",
    transform: "translate(13.615 51.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3666",
    d: "M25.681 1021.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3666",
    transform: "translate(13.615 54.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3667",
    d: "M25.681 1024.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3667",
    transform: "translate(13.615 57.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3668",
    d: "M25.681 1028.078a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3668",
    transform: "translate(13.615 61.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3669",
    d: "M29.181 965.078a2.466 2.466 0 1 1-2.465-2.465 2.466 2.466 0 0 1 2.465 2.465z",
    className: "cls-1",
    "data-name": "Path 3669",
    transform: "translate(17.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3670",
    d: "M29.181 968.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3670",
    transform: "translate(17.019 3.404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3671",
    d: "M29.181 972.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3671",
    transform: "translate(17.019 6.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3672",
    d: "M29.181 975.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3672",
    transform: "translate(17.019 10.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3673",
    d: "M29.181 979.077a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3673",
    transform: "translate(17.019 13.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3674",
    d: "M29.181 982.578a2.466 2.466 0 1 1-2.465-2.466 2.466 2.466 0 0 1 2.465 2.466z",
    className: "cls-1",
    "data-name": "Path 3674",
    transform: "translate(17.019 17.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3675",
    d: "M29.181 986.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3675",
    transform: "translate(17.019 20.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3676",
    d: "M29.181 989.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3676",
    transform: "translate(17.019 23.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3677",
    d: "M29.181 993.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3677",
    transform: "translate(17.019 27.23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3678",
    d: "M29.181 996.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3678",
    transform: "translate(17.019 30.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3679",
    d: "M29.181 1000.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3679",
    transform: "translate(17.019 34.037)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3680",
    d: "M29.181 1003.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3680",
    transform: "translate(17.019 37.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3681",
    d: "M29.181 1007.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3681",
    transform: "translate(17.019 40.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3682",
    d: "M29.181 1010.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3682",
    transform: "translate(17.019 44.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3683",
    d: "M29.181 1014.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3683",
    transform: "translate(17.019 47.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3684",
    d: "M29.181 1017.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3684",
    transform: "translate(17.019 51.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3685",
    d: "M29.181 1021.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3685",
    transform: "translate(17.019 54.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3686",
    d: "M29.181 1024.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3686",
    transform: "translate(17.019 57.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3687",
    d: "M29.181 1028.078a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3687",
    transform: "translate(17.019 61.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3688",
    d: "M29.181 1031.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3688",
    transform: "translate(17.019 64.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3689",
    d: "M32.681 965.078a2.466 2.466 0 1 1-2.465-2.465 2.466 2.466 0 0 1 2.465 2.465z",
    className: "cls-1",
    "data-name": "Path 3689",
    transform: "translate(20.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3690",
    d: "M32.681 968.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3690",
    transform: "translate(20.422 3.404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3691",
    d: "M32.681 972.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3691",
    transform: "translate(20.422 6.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3692",
    d: "M32.681 975.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3692",
    transform: "translate(20.422 10.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3693",
    d: "M32.681 979.077a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3693",
    transform: "translate(20.422 13.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3694",
    d: "M32.681 982.578a2.466 2.466 0 1 1-2.465-2.466 2.466 2.466 0 0 1 2.465 2.466z",
    className: "cls-1",
    "data-name": "Path 3694",
    transform: "translate(20.422 17.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3695",
    d: "M32.681 986.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3695",
    transform: "translate(20.422 20.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3696",
    d: "M32.681 989.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3696",
    transform: "translate(20.422 23.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3697",
    d: "M32.681 993.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3697",
    transform: "translate(20.422 27.23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3698",
    d: "M32.681 996.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3698",
    transform: "translate(20.422 30.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3699",
    d: "M32.681 1000.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3699",
    transform: "translate(20.422 34.037)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3700",
    d: "M32.681 1003.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3700",
    transform: "translate(20.422 37.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3701",
    d: "M32.681 1007.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3701",
    transform: "translate(20.422 40.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3702",
    d: "M32.681 1010.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3702",
    transform: "translate(20.422 44.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3703",
    d: "M32.681 1014.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3703",
    transform: "translate(20.422 47.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3704",
    d: "M32.681 1017.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3704",
    transform: "translate(20.422 51.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3705",
    d: "M32.681 1021.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3705",
    transform: "translate(20.422 54.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3706",
    d: "M32.681 1024.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3706",
    transform: "translate(20.422 57.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3707",
    d: "M32.681 1028.078a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3707",
    transform: "translate(20.422 61.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3708",
    d: "M32.681 1031.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3708",
    transform: "translate(20.422 64.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3709",
    d: "M36.181 965.078a2.466 2.466 0 1 1-2.465-2.465 2.466 2.466 0 0 1 2.465 2.465z",
    className: "cls-1",
    "data-name": "Path 3709",
    transform: "translate(23.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3710",
    d: "M36.181 968.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3710",
    transform: "translate(23.826 3.404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3711",
    d: "M36.181 972.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3711",
    transform: "translate(23.826 6.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3712",
    d: "M36.181 975.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3712",
    transform: "translate(23.826 10.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3713",
    d: "M36.181 979.077a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3713",
    transform: "translate(23.826 13.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3714",
    d: "M36.181 982.578a2.466 2.466 0 1 1-2.465-2.466 2.466 2.466 0 0 1 2.465 2.466z",
    className: "cls-1",
    "data-name": "Path 3714",
    transform: "translate(23.826 17.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3715",
    d: "M36.181 986.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3715",
    transform: "translate(23.826 20.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3716",
    d: "M36.181 989.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3716",
    transform: "translate(23.826 23.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3717",
    d: "M36.181 993.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3717",
    transform: "translate(23.826 27.23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3718",
    d: "M36.181 996.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3718",
    transform: "translate(23.826 30.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3719",
    d: "M36.181 1000.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3719",
    transform: "translate(23.826 34.037)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3720",
    d: "M36.181 1003.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3720",
    transform: "translate(23.826 37.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3721",
    d: "M36.181 1007.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3721",
    transform: "translate(23.826 40.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3722",
    d: "M36.181 1010.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3722",
    transform: "translate(23.826 44.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3723",
    d: "M36.181 1014.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3723",
    transform: "translate(23.826 47.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3724",
    d: "M36.181 1017.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3724",
    transform: "translate(23.826 51.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3725",
    d: "M36.181 1021.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3725",
    transform: "translate(23.826 54.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3726",
    d: "M36.181 1024.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3726",
    transform: "translate(23.826 57.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3727",
    d: "M36.181 1028.078a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3727",
    transform: "translate(23.826 61.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3728",
    d: "M36.181 1031.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3728",
    transform: "translate(23.826 64.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3729",
    d: "M39.681 965.078a2.466 2.466 0 1 1-2.465-2.465 2.466 2.466 0 0 1 2.465 2.465z",
    className: "cls-1",
    "data-name": "Path 3729",
    transform: "translate(27.23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3730",
    d: "M39.681 968.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3730",
    transform: "translate(27.23 3.404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3731",
    d: "M39.681 972.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3731",
    transform: "translate(27.23 6.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3732",
    d: "M39.681 975.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3732",
    transform: "translate(27.23 10.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3733",
    d: "M39.681 979.077a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3733",
    transform: "translate(27.23 13.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3734",
    d: "M39.681 982.578a2.466 2.466 0 1 1-2.465-2.466 2.466 2.466 0 0 1 2.465 2.466z",
    className: "cls-1",
    "data-name": "Path 3734",
    transform: "translate(27.23 17.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3735",
    d: "M39.681 986.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3735",
    transform: "translate(27.23 20.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3736",
    d: "M39.681 989.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3736",
    transform: "translate(27.23 23.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3737",
    d: "M39.681 993.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3737",
    transform: "translate(27.23 27.23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3738",
    d: "M39.681 996.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3738",
    transform: "translate(27.23 30.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3739",
    d: "M39.681 1000.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3739",
    transform: "translate(27.23 34.037)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3740",
    d: "M39.681 1003.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3740",
    transform: "translate(27.23 37.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3741",
    d: "M39.681 1007.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3741",
    transform: "translate(27.23 40.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3742",
    d: "M39.681 1010.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3742",
    transform: "translate(27.23 44.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3743",
    d: "M39.681 1014.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3743",
    transform: "translate(27.23 47.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3744",
    d: "M39.681 1017.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3744",
    transform: "translate(27.23 51.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3745",
    d: "M39.681 1021.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3745",
    transform: "translate(27.23 54.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3746",
    d: "M39.681 1024.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3746",
    transform: "translate(27.23 57.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3747",
    d: "M39.681 1028.078a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3747",
    transform: "translate(27.23 61.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3748",
    d: "M39.681 1031.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3748",
    transform: "translate(27.23 64.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3749",
    d: "M43.181 965.078a2.466 2.466 0 1 1-2.465-2.465 2.466 2.466 0 0 1 2.465 2.465z",
    className: "cls-1",
    "data-name": "Path 3749",
    transform: "translate(30.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3750",
    d: "M43.181 968.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3750",
    transform: "translate(30.633 3.404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3751",
    d: "M43.181 972.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3751",
    transform: "translate(30.633 6.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3752",
    d: "M43.181 975.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3752",
    transform: "translate(30.633 10.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3753",
    d: "M43.181 979.077a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3753",
    transform: "translate(30.633 13.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3754",
    d: "M43.181 982.578a2.466 2.466 0 1 1-2.465-2.466 2.466 2.466 0 0 1 2.465 2.466z",
    className: "cls-1",
    "data-name": "Path 3754",
    transform: "translate(30.633 17.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3755",
    d: "M43.181 986.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3755",
    transform: "translate(30.633 20.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3756",
    d: "M43.181 989.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3756",
    transform: "translate(30.633 23.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3757",
    d: "M43.181 993.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3757",
    transform: "translate(30.633 27.23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3758",
    d: "M43.181 996.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3758",
    transform: "translate(30.633 30.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3759",
    d: "M43.181 1000.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3759",
    transform: "translate(30.633 34.037)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3760",
    d: "M43.181 1003.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3760",
    transform: "translate(30.633 37.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3761",
    d: "M43.181 1007.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3761",
    transform: "translate(30.633 40.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3762",
    d: "M43.181 1010.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3762",
    transform: "translate(30.633 44.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3763",
    d: "M43.181 1014.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3763",
    transform: "translate(30.633 47.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3764",
    d: "M43.181 1017.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3764",
    transform: "translate(30.633 51.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3765",
    d: "M43.181 1021.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3765",
    transform: "translate(30.633 54.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3766",
    d: "M43.181 1024.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3766",
    transform: "translate(30.633 57.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3767",
    d: "M43.181 1028.078a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3767",
    transform: "translate(30.633 61.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3768",
    d: "M43.181 1031.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3768",
    transform: "translate(30.633 64.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3769",
    d: "M43.181 1035.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3769",
    transform: "translate(30.633 68.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3770",
    d: "M46.681 965.078a2.466 2.466 0 1 1-2.465-2.465 2.466 2.466 0 0 1 2.465 2.465z",
    className: "cls-1",
    "data-name": "Path 3770",
    transform: "translate(34.037)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3771",
    d: "M46.681 968.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3771",
    transform: "translate(34.037 3.404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3772",
    d: "M46.681 972.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3772",
    transform: "translate(34.037 6.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3773",
    d: "M46.681 975.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3773",
    transform: "translate(34.037 10.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3774",
    d: "M46.681 979.077a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3774",
    transform: "translate(34.037 13.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3775",
    d: "M46.681 982.578a2.466 2.466 0 1 1-2.465-2.466 2.466 2.466 0 0 1 2.465 2.466z",
    className: "cls-1",
    "data-name": "Path 3775",
    transform: "translate(34.037 17.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3776",
    d: "M46.681 986.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3776",
    transform: "translate(34.037 20.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3777",
    d: "M46.681 989.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3777",
    transform: "translate(34.037 23.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3778",
    d: "M46.681 993.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3778",
    transform: "translate(34.037 27.23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3779",
    d: "M46.681 996.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3779",
    transform: "translate(34.037 30.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3780",
    d: "M46.681 1000.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3780",
    transform: "translate(34.037 34.037)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3781",
    d: "M46.681 1003.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3781",
    transform: "translate(34.037 37.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3782",
    d: "M46.681 1007.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3782",
    transform: "translate(34.037 40.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3783",
    d: "M46.681 1010.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3783",
    transform: "translate(34.037 44.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3784",
    d: "M46.681 1014.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3784",
    transform: "translate(34.037 47.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3785",
    d: "M46.681 1017.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3785",
    transform: "translate(34.037 51.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3786",
    d: "M46.681 1021.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3786",
    transform: "translate(34.037 54.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3787",
    d: "M46.681 1024.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3787",
    transform: "translate(34.037 57.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3788",
    d: "M46.681 1028.078a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3788",
    transform: "translate(34.037 61.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3789",
    d: "M46.681 1031.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3789",
    transform: "translate(34.037 64.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3790",
    d: "M46.681 1035.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3790",
    transform: "translate(34.037 68.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3791",
    d: "M50.181 965.078a2.466 2.466 0 1 1-2.465-2.465 2.466 2.466 0 0 1 2.465 2.465z",
    className: "cls-1",
    "data-name": "Path 3791",
    transform: "translate(37.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3792",
    d: "M50.181 968.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3792",
    transform: "translate(37.441 3.404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3793",
    d: "M50.181 972.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3793",
    transform: "translate(37.441 6.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3794",
    d: "M50.181 975.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3794",
    transform: "translate(37.441 10.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3795",
    d: "M50.181 979.077a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3795",
    transform: "translate(37.441 13.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3796",
    d: "M50.181 982.578a2.466 2.466 0 1 1-2.465-2.466 2.466 2.466 0 0 1 2.465 2.466z",
    className: "cls-1",
    "data-name": "Path 3796",
    transform: "translate(37.441 17.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3797",
    d: "M50.181 986.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3797",
    transform: "translate(37.441 20.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3798",
    d: "M50.181 989.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3798",
    transform: "translate(37.441 23.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3799",
    d: "M50.181 993.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3799",
    transform: "translate(37.441 27.23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3800",
    d: "M50.181 996.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3800",
    transform: "translate(37.441 30.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3801",
    d: "M50.181 1000.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3801",
    transform: "translate(37.441 34.037)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3802",
    d: "M50.181 1003.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3802",
    transform: "translate(37.441 37.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3803",
    d: "M50.181 1007.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3803",
    transform: "translate(37.441 40.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3804",
    d: "M50.181 1010.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3804",
    transform: "translate(37.441 44.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3805",
    d: "M50.181 1014.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3805",
    transform: "translate(37.441 47.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3806",
    d: "M50.181 1017.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3806",
    transform: "translate(37.441 51.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3807",
    d: "M50.181 1021.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3807",
    transform: "translate(37.441 54.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3808",
    d: "M50.181 1024.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3808",
    transform: "translate(37.441 57.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3809",
    d: "M50.181 1028.078a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3809",
    transform: "translate(37.441 61.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3810",
    d: "M50.181 1031.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3810",
    transform: "translate(37.441 64.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3811",
    d: "M53.681 965.078a2.466 2.466 0 1 1-2.465-2.465 2.466 2.466 0 0 1 2.465 2.465z",
    className: "cls-1",
    "data-name": "Path 3811",
    transform: "translate(40.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3812",
    d: "M53.681 968.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3812",
    transform: "translate(40.844 3.404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3813",
    d: "M53.681 972.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3813",
    transform: "translate(40.844 6.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3814",
    d: "M53.681 975.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3814",
    transform: "translate(40.844 10.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3815",
    d: "M53.681 979.077a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3815",
    transform: "translate(40.844 13.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3816",
    d: "M53.681 982.578a2.466 2.466 0 1 1-2.465-2.466 2.466 2.466 0 0 1 2.465 2.466z",
    className: "cls-1",
    "data-name": "Path 3816",
    transform: "translate(40.844 17.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3817",
    d: "M53.681 986.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3817",
    transform: "translate(40.844 20.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3818",
    d: "M53.681 989.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3818",
    transform: "translate(40.844 23.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3819",
    d: "M53.681 993.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3819",
    transform: "translate(40.844 27.23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3820",
    d: "M53.681 1003.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3820",
    transform: "translate(40.844 37.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3821",
    d: "M53.681 1007.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3821",
    transform: "translate(40.844 40.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3822",
    d: "M53.681 1010.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3822",
    transform: "translate(40.844 44.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3823",
    d: "M53.681 1014.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3823",
    transform: "translate(40.844 47.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3824",
    d: "M53.681 1017.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3824",
    transform: "translate(40.844 51.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3825",
    d: "M53.681 1021.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3825",
    transform: "translate(40.844 54.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3826",
    d: "M53.681 1024.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3826",
    transform: "translate(40.844 57.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3827",
    d: "M53.681 1028.078a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3827",
    transform: "translate(40.844 61.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3828",
    d: "M53.681 1031.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3828",
    transform: "translate(40.844 64.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3829",
    d: "M53.681 1035.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3829",
    transform: "translate(40.844 68.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3830",
    d: "M57.181 975.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3830",
    transform: "translate(44.248 10.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3831",
    d: "M57.181 979.077a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3831",
    transform: "translate(44.248 13.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3832",
    d: "M57.181 982.578a2.466 2.466 0 1 1-2.465-2.466 2.466 2.466 0 0 1 2.465 2.466z",
    className: "cls-1",
    "data-name": "Path 3832",
    transform: "translate(44.248 17.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3833",
    d: "M57.181 986.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3833",
    transform: "translate(44.248 20.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3834",
    d: "M57.181 1003.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3834",
    transform: "translate(44.248 37.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3835",
    d: "M57.181 1007.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3835",
    transform: "translate(44.248 40.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3836",
    d: "M57.181 1010.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3836",
    transform: "translate(44.248 44.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3837",
    d: "M57.181 1014.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3837",
    transform: "translate(44.248 47.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3838",
    d: "M57.181 1017.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3838",
    transform: "translate(44.248 51.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3839",
    d: "M57.181 1021.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3839",
    transform: "translate(44.248 54.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3840",
    d: "M57.181 1024.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3840",
    transform: "translate(44.248 57.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3841",
    d: "M57.181 1028.078a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3841",
    transform: "translate(44.248 61.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3842",
    d: "M57.181 1031.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3842",
    transform: "translate(44.248 64.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3843",
    d: "M57.181 1035.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3843",
    transform: "translate(44.248 68.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3844",
    d: "M57.181 1038.578a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3844",
    transform: "translate(44.248 71.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3845",
    d: "M60.681 1003.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3845",
    transform: "translate(47.652 37.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3846",
    d: "M60.681 1007.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3846",
    transform: "translate(47.652 40.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3847",
    d: "M60.681 1010.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3847",
    transform: "translate(47.652 44.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3848",
    d: "M60.681 1014.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3848",
    transform: "translate(47.652 47.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3849",
    d: "M60.681 1017.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3849",
    transform: "translate(47.652 51.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3850",
    d: "M60.681 1021.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3850",
    transform: "translate(47.652 54.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3851",
    d: "M60.681 1024.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3851",
    transform: "translate(47.652 57.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3852",
    d: "M60.681 1028.078a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3852",
    transform: "translate(47.652 61.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3853",
    d: "M60.681 1031.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3853",
    transform: "translate(47.652 64.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3854",
    d: "M60.681 1035.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3854",
    transform: "translate(47.652 68.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3855",
    d: "M60.681 1038.578a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3855",
    transform: "translate(47.652 71.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3856",
    d: "M64.181 1003.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3856",
    transform: "translate(51.056 37.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3857",
    d: "M64.181 1007.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3857",
    transform: "translate(51.056 40.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    d: "M64.181 1010.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3858",
    transform: "translate(51.056 44.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    d: "M64.181 1014.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3859",
    transform: "translate(51.056 47.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3860",
    d: "M64.181 1017.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3860",
    transform: "translate(51.056 51.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3861",
    d: "M64.181 1021.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3861",
    transform: "translate(51.056 54.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3862",
    d: "M64.181 1024.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3862",
    transform: "translate(51.056 57.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3863",
    d: "M64.181 1028.078a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3863",
    transform: "translate(51.056 61.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3864",
    d: "M64.181 1031.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3864",
    transform: "translate(51.056 64.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3865",
    d: "M64.181 1035.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3865",
    transform: "translate(51.056 68.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3866",
    d: "M64.181 1038.578a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3866",
    transform: "translate(51.056 71.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3867",
    d: "M64.181 1042.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3867",
    transform: "translate(51.056 74.881)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3868",
    d: "M67.681 1003.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3868",
    transform: "translate(54.459 37.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3869",
    d: "M67.681 1007.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3869",
    transform: "translate(54.459 40.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3870",
    d: "M67.681 1010.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3870",
    transform: "translate(54.459 44.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3871",
    d: "M67.681 1014.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3871",
    transform: "translate(54.459 47.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3872",
    d: "M67.681 1017.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3872",
    transform: "translate(54.459 51.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3873",
    d: "M67.681 1021.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3873",
    transform: "translate(54.459 54.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3874",
    d: "M67.681 1024.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3874",
    transform: "translate(54.459 57.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3875",
    d: "M67.681 1028.078a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3875",
    transform: "translate(54.459 61.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3876",
    d: "M67.681 1031.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3876",
    transform: "translate(54.459 64.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3877",
    d: "M67.681 1035.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3877",
    transform: "translate(54.459 68.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3878",
    d: "M67.681 1038.578a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3878",
    transform: "translate(54.459 71.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3879",
    d: "M67.681 1042.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3879",
    transform: "translate(54.459 74.881)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3880",
    d: "M71.181 1003.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3880",
    transform: "translate(57.863 37.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3881",
    d: "M71.181 1007.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3881",
    transform: "translate(57.863 40.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3882",
    d: "M71.181 1010.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3882",
    transform: "translate(57.863 44.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3883",
    d: "M71.181 1014.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3883",
    transform: "translate(57.863 47.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3884",
    d: "M71.181 1017.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3884",
    transform: "translate(57.863 51.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3885",
    d: "M71.181 1021.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3885",
    transform: "translate(57.863 54.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3886",
    d: "M71.181 1024.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3886",
    transform: "translate(57.863 57.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3887",
    d: "M71.181 1028.078a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3887",
    transform: "translate(57.863 61.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3888",
    d: "M71.181 1031.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3888",
    transform: "translate(57.863 64.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3889",
    d: "M71.181 1035.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3889",
    transform: "translate(57.863 68.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3890",
    d: "M71.181 1038.578a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3890",
    transform: "translate(57.863 71.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3891",
    d: "M74.681 1003.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3891",
    transform: "translate(61.267 37.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3892",
    d: "M74.681 1007.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3892",
    transform: "translate(61.267 40.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3893",
    d: "M74.681 1010.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3893",
    transform: "translate(61.267 44.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3894",
    d: "M74.681 1014.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3894",
    transform: "translate(61.267 47.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3895",
    d: "M74.681 1017.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3895",
    transform: "translate(61.267 51.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3896",
    d: "M74.681 1021.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3896",
    transform: "translate(61.267 54.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3897",
    d: "M74.681 1024.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3897",
    transform: "translate(61.267 57.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3898",
    d: "M74.681 1028.078a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3898",
    transform: "translate(61.267 61.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3899",
    d: "M74.681 1031.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3899",
    transform: "translate(61.267 64.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3900",
    d: "M74.681 1035.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3900",
    transform: "translate(61.267 68.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3901",
    d: "M74.681 1038.578a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3901",
    transform: "translate(61.267 71.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3902",
    d: "M74.681 1042.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3902",
    transform: "translate(61.267 74.881)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3903",
    d: "M78.181 1003.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3903",
    transform: "translate(64.67 37.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3904",
    d: "M78.181 1007.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3904",
    transform: "translate(64.67 40.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3905",
    d: "M78.181 1010.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3905",
    transform: "translate(64.67 44.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3906",
    d: "M78.181 1014.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3906",
    transform: "translate(64.67 47.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3907",
    d: "M78.181 1017.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3907",
    transform: "translate(64.67 51.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3908",
    d: "M78.181 1021.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3908",
    transform: "translate(64.67 54.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3909",
    d: "M78.181 1024.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3909",
    transform: "translate(64.67 57.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3910",
    d: "M78.181 1028.078a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3910",
    transform: "translate(64.67 61.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3911",
    d: "M78.181 1031.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3911",
    transform: "translate(64.67 64.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3912",
    d: "M78.181 1035.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3912",
    transform: "translate(64.67 68.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3913",
    d: "M78.181 1038.578a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3913",
    transform: "translate(64.67 71.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3914",
    d: "M81.681 1003.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3914",
    transform: "translate(68.074 37.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3915",
    d: "M81.681 1007.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3915",
    transform: "translate(68.074 40.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3916",
    d: "M81.681 1010.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3916",
    transform: "translate(68.074 44.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3917",
    d: "M81.681 1014.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3917",
    transform: "translate(68.074 47.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3918",
    d: "M81.681 1017.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3918",
    transform: "translate(68.074 51.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3919",
    d: "M81.681 1021.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3919",
    transform: "translate(68.074 54.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3920",
    d: "M81.681 1024.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3920",
    transform: "translate(68.074 57.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3921",
    d: "M81.681 1028.078a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3921",
    transform: "translate(68.074 61.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3922",
    d: "M81.681 1031.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3922",
    transform: "translate(68.074 64.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3923",
    d: "M81.681 1035.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3923",
    transform: "translate(68.074 68.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3924",
    d: "M85.181 1014.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3924",
    transform: "translate(71.478 47.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3925",
    d: "M85.181 1017.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3925",
    transform: "translate(71.478 51.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3926",
    d: "M85.181 1024.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3926",
    transform: "translate(71.478 57.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3927",
    d: "M85.181 1028.078a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3927",
    transform: "translate(71.478 61.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3928",
    d: "M85.181 1031.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3928",
    transform: "translate(71.478 64.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3929",
    d: "M85.181 1035.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3929",
    transform: "translate(71.478 68.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3930",
    d: "M88.681 1017.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3930",
    transform: "translate(74.881 51.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3931",
    d: "M88.681 1021.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3931",
    transform: "translate(74.881 54.459)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3932",
    d: "M88.681 1024.578a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3932",
    transform: "translate(74.881 57.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3933",
    d: "M88.681 1028.078a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3933",
    transform: "translate(74.881 61.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3934",
    d: "M88.681 1035.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3934",
    transform: "translate(74.881 68.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3935",
    d: "M88.681 1038.578a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3935",
    transform: "translate(74.881 71.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3936",
    d: "M92.181 1035.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3936",
    transform: "translate(78.285 68.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3937",
    d: "M92.181 1038.578a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3937",
    transform: "translate(78.285 71.478)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3938",
    d: "M95.681 1035.078a2.466 2.466 0 1 1-2.466-2.466 2.466 2.466 0 0 1 2.466 2.466z",
    className: "cls-1",
    "data-name": "Path 3938",
    transform: "translate(81.689 68.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3939",
    d: "M95.681 1038.578a2.466 2.466 0 1 1-2.466-2.465 2.466 2.466 0 0 1 2.466 2.465z",
    className: "cls-1",
    "data-name": "Path 3939",
    transform: "translate(81.689 71.478)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLouisiana);
export default __webpack_public_path__ + "static/media/icon-louisiana.e13db98e7bf11d6ff2dccf1d430fbae4.svg";
export { ForwardRef as ReactComponent };